import { RHFSwitch, RHFTextField } from "@components/hook-form";
import { Box, Grid } from "@mui/material";
import RHAAutoCompleteWithZero from "@pages/Expense/Employee/RHAAutoCompleteWithZero";
import React, { useMemo } from "react";
import { getTaxCategories } from "../constants";

interface ITaxesFormProps {
  taxId?: string;
  isSubmitting: boolean;
  isWithHoldingTaxVisible: boolean;
  hasItemTaxFromManualForm?: boolean;
  translate: (key: string) => string;
}

export const TaxesForm: React.FC<ITaxesFormProps> = (props) => {
  const {
    isSubmitting,
    translate,
    isWithHoldingTaxVisible,
    hasItemTaxFromManualForm,
  } = props;
  const taxCategories = useMemo(() => getTaxCategories(translate), [translate]);
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={6}>
        <RHFTextField
          name="code"
          label={translate("code")}
          disabled={isSubmitting}
        />
      </Grid>

      <Grid item xs={6}>
        <RHAAutoCompleteWithZero
          name="taxType"
          label={translate("tax_type")}
          options={taxCategories}
          disabled={isSubmitting}
          freeSolo
          placeholder={""}
          onKeyDown={handleKeyDown}
        />
      </Grid>

      <Grid item xs={12}>
        <RHFTextField
          name="description"
          label={translate("description")}
          multiline
          rows={2}
          disabled={isSubmitting}
        />
      </Grid>

      <Grid item xs={6}>
        <RHFTextField
          name="rate"
          label={`${translate("rate")} (%)`}
          disabled={isSubmitting}
          inputProps={{ min: 0 }}
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e" || e.key === "+") {
              e.preventDefault();
            }
          }}
        />
      </Grid>

      <Grid
        item
        xs={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {isWithHoldingTaxVisible && (
          <>
            <Box
              sx={{
                color: "#657482",
                fontWeight: 700,
                fontSize: "12px",
              }}
            >
              {translate("is_withholding_tax")}
            </Box>
            <RHFSwitch
              name="isWithholdingTax"
              label=""
              disabled={isSubmitting || hasItemTaxFromManualForm}
              sx={{ m: 0 }}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};
